import React from "react";

const Phone = () => {
  return (
    <div className="phone__content">
      <div className="phone">
        <div className="shadow1"></div>
        <div className="shadow2"></div>
        <div className="container">
          <div className="block n1"></div>
          <div className="block n2"></div>
          <div className="block n3"></div>
          <div className="block n4"></div>
          <div className="block n5"></div>
          <div className="block n6"></div>
          <div className="block n7"></div>
          <div className="block n8"></div>
          <div className="block n9"></div>
          <div className="block n10"></div>
          <div className="block n11"></div>
          <div className="block n12"></div>
        </div>
      </div>
    </div>
  );
};

export default Phone;
